module.exports = __webpack_public_path__ + "img/pricing-Illustration.e1e329dc.svg";